const routes = {
  root: {
    path: "/",
  },
  forbidden: {
    path: "/403",
  },
  home: {
    path: "/home",
  },
  "sign-in": {
    path: "/sign-in",
  },
  "sign-out": {
    path: "/sign-out",
  },
  "sign-up": {
    path: "/sign-up",
  },
  "sso-callback": {
    path: "/sso-callback",
  },
  "sign-up-welcome": {
    path: "/sign-up/welcome",
  },
  "sign-up-complete": {
    path: "/sign-up/complete",
  },
  welcome: {
    path: "/welcome",
  },
  organization: {
    path: "/organization/:orgSlug",
  },
  // PLATFORM
  "platform-admin": {
    path: "/admin",
  },
  "platform-admin-organizations": {
    path: "/admin/organizations",
  },
  // ORG
  "org-root": {
    path: "/org",
  },
  org: {
    path: "/org/:orgSlug",
  },
  "org-admin": {
    path: "/org/:orgSlug/admin",
  },
  "org-admin-workspaces": {
    path: "/org/:orgSlug/admin/workspaces",
  },
  "org-admin-team": {
    path: "/org/:orgSlug/admin/team",
  },
  // WORKSPACE
  "workspace-root": {
    path: "/org/:orgSlug/workspace",
  },
  workspace: {
    path: "/org/:orgSlug/workspace/:workspaceId",
  },
  "workspace-home": {
    path: "/org/:orgSlug/workspace/:workspaceId",
  },
  // AUDIENCES
  audiences: {
    path: "/org/:orgSlug/workspace/:workspaceId/audiences",
  },
  "audience-detail": {
    path: "/org/:orgSlug/workspace/:workspaceId/audiences/detail/:audienceId",
  },
  // PIXELS
  pixels: {
    path: "/org/:orgSlug/workspace/:workspaceId/pixels",
  },
  "create-pixel": {
    path: "/org/:orgSlug/workspace/:workspaceId/create-pixel",
  },
  "create-pixel-id": {
    path: "/org/:orgSlug/workspace/:workspaceId/create-pixel/:pixelId",
  },
  "create-pixel-step": {
    path: "/org/:orgSlug/workspace/:workspaceId/create-pixel/:pixelId/:stepId",
  },
  // DESTINATIONS
  destinations: {
    path: "/org/:orgSlug/workspace/:workspaceId/destinations",
  },
  "destination-detail": {
    path: "/org/:orgSlug/workspace/:workspaceId/destinations/detail/:platformId",
  },
  // TAGS
  tags: {
    path: "/org/:orgSlug/workspace/:workspaceId/tags",
  },
  "tag-detail": {
    path: "/org/:orgSlug/workspace/:workspaceId/tags/:tagId",
  },
  // builders
  "create-campaign": {
    path: "/org/:orgSlug/workspace/:workspaceId/create-campaign",
  },
  "create-campaign-id": {
    path: "/org/:orgSlug/workspace/:workspaceId/create-campaign/:campaignId",
  },
  "create-campaign-step": {
    path: "/org/:orgSlug/workspace/:workspaceId/create-campaign/:campaignId/:stepId",
  },
  "create-audience": {
    path: "/org/:orgSlug/workspace/:workspaceId/create-audience",
  },
  "create-audience-new": {
    path: "/org/:orgSlug/workspace/:workspaceId/create-audience/:creationMethod",
  },
  "create-audience-id": {
    path: "/org/:orgSlug/workspace/:workspaceId/create-audience/:creationMethod/:audienceId",
  },
  "create-audience-step": {
    path: "/org/:orgSlug/workspace/:workspaceId/create-audience/:creationMethod/:audienceId/:stepId",
  },
  workspaces: {
    path: "/workspaces",
  },
  onboarding: {
    path: "/onboarding",
  },
  onboardingStep: {
    path: "/onboarding/:stepId",
  },
  onboardingWorkspaceCreate: {
    path: "/onboarding/workspace/create",
  },
  acceptInvitation: {
    path: "/accept-invitation",
  },
  reports: {
    path: "/org/:orgSlug/workspace/:workspaceId/reports",
  },
  "reports-all": {
    path: "/org/:orgSlug/workspace/:workspaceId/reports/all",
  },
  "reports-website": {
    path: "/org/:orgSlug/workspace/:workspaceId/reports/website",
  },
  "reports-campaign": {
    path: "/org/:orgSlug/workspace/:workspaceId/reports/campaign",
  },
  "reports-script-lift": {
    path: "/org/:orgSlug/workspace/:workspaceId/reports/script-lift",
  },
  "build-report": {
    path: "/org/:orgSlug/workspace/:workspaceId/create-report/:type/:reportId",
  },
  "create-report": {
    path: "/org/:orgSlug/workspace/:workspaceId/create-report",
  },
  campaigns: {
    path: "/org/:orgSlug/workspace/:workspaceId/campaigns",
  },
  "campaign-detail": {
    path: "/org/:orgSlug/workspace/:workspaceId/campaigns/detail/:campaignId",
  },
  dashboard: {
    path: "/org/:orgSlug/workspace/:workspaceId",
  },
  "create-script-lift": {
    path: "/org/:orgSlug/workspace/:workspaceId/create-script-lift-report",
  },
  "create-script-lift-id": {
    path: "/org/:orgSlug/workspace/:workspaceId/create-script-lift-report/:reportId",
  },
  "create-script-lift-step": {
    path: "/org/:orgSlug/workspace/:workspaceId/create-script-lift-report/:reportId/:stepId",
  },
  "script-lift-report-detail": {
    path: "/org/:orgSlug/workspace/:workspaceId/reports/script-lift/:scriptLiftReportId",
  },
};

export const routeService = {
  getUrl: (
    resource: keyof typeof routes,
    params: Record<string, string> = {},
    queryParams: Record<string, string> = {},
  ) => {
    const route = routes[resource];
    if (!route) {
      throw new Error(`Route not found for resource: ${resource}`);
    }
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(queryParams).filter(([_, v]) => v)),
    ).toString();
    return `${route.path.replace(
      /:(\w+)/g,
      (_, param) => params[param] || `:${param}`,
    )}${queryString ? `?${queryString}` : ""}`;
  },
};
